module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"defaultBody":"Default body","close":"Schließen"},"en":{"defaultBody":"Default body","close":"Close"}}')
  delete Component.options._Ctor
}
